import { useState, useEffect } from "react";
import LoginService from "../api/services/login.service";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../states/store";
import { useCookies } from "react-cookie";
import {getUserAccessDetails,getUserCountryDetails} from "../states/slice/loginSlice";

const useFetchCountryUseraccess = () => {
  const loginReduxData = useSelector((state: RootState) => state.rootReducer.LoginReducer
);
  console.log(loginReduxData);
  const [countryData, setCountryData] = useState<{
    error: boolean;
    data: any[];
  }>({
    error: false,
    data: []
  });
  const [userAccessData, setAccessData] = useState<{
    error: boolean;
    data: any[];
  }>({
    error: false,
    data: []
  });
  const action = useDispatch();
  const [cookies, setCookie, removeCookie] = useCookies(["accessToken"]);
  const getUserAccessMenuDetails = async () => {
    if(localStorage.getItem("countryId") && localStorage.getItem("countryId") != "null" && localStorage.getItem("countryId") != "undefined") {
    // let menuAccessResponse: any = await LoginService.menuAccessDetails();
    // console.log("menuAccessResponse", menuAccessResponse);
    // if (menuAccessResponse?.status == 200) {
    //   const menuAccessRes: any = menuAccessResponse.data.serviceResponse?.mainModuleResponseDto;
    //   if (menuAccessRes && menuAccessRes.length) {
       
    //     setAccessData((prevState: any) => ({
    //       ...prevState,
    //       data: menuAccessRes,
    //     }));
    //     action({
    //       type: "updateLoginDetails",
    //       payload: {
    //         name: "sideMenuData",
    //         value: menuAccessRes,
    //       },
    //     });
    //   } else {
        
    //     setAccessData((prevState: any) => ({
    //       ...prevState,
    //       data: [],
    //     }));
    //   }
    // } else {
     
    //   setAccessData((prevState: any) => ({
    //     ...prevState,
    //     data: [],
    //     error: true,
    //   }));
    // }
    action(getUserAccessDetails());
  }

  };
  const fetchCountry = async () => {
    //return JWTInterceptor.get(`${process.env.REACT_APP_Admin_APP_BASE_URL}UserAccess/getuserCountryList`)

    //   let countryResponse:any = await LoginService.countryDetails();
    // if (countryResponse?.status == 200) {
    //     const res: any = countryResponse.data.serviceResponse;
    //     if (res && res.getUserCountryLists.length) {
    //     setCountryData((prevState: any) => ({
    //         ...prevState,
    //         data: res.getUserCountryLists,
    //         }));
    //     } else {
    //         setCountryData((prevState: any) => ({
    //             ...prevState,
    //             data: [],
    //             }));
    //     }
    //       localStorage.setItem("countryId", res.getUserCountryLists?.[0]?.countryId);
    //       localStorage.setItem("adminType", JSON.stringify(res.adminResponse?.[0]));
    //     } else {
    //         setCountryData((prevState: any) => ({
    //             ...prevState,
    //             data: [],
    //             error: true,
    //         }));
    //     }
    action(getUserCountryDetails());
  };
  

  useEffect(() => {    
    if (loginReduxData.tokenDetails?.accessToken || cookies.accessToken && cookies.accessToken!== "") {
    fetchCountry();    
    }
  }, [ loginReduxData?.tokenDetails]);

  useEffect(() => {    
    getUserAccessMenuDetails();
  }, [ loginReduxData?.selectedCounty]);

  return {countryData, userAccessData};
};

export default useFetchCountryUseraccess;